export default "__VITE_ASSET__e1f81ff7__"